/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData model module.
 * @module model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData
 * @version 1.0
 */
class PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData</code>.
     * @alias module:model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData
     */
    constructor() { 
        
        PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData} The populated <code>PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData();

            if (data.hasOwnProperty('targetDate')) {
                obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
            }
            if (data.hasOwnProperty('transactionCount')) {
                obj['transactionCount'] = ApiClient.convertToType(data['transactionCount'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalPrice')) {
                obj['transactionTotalPrice'] = ApiClient.convertToType(data['transactionTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('transactionTotalFee')) {
                obj['transactionTotalFee'] = ApiClient.convertToType(data['transactionTotalFee'], 'Number');
            }
            if (data.hasOwnProperty('registerCount')) {
                obj['registerCount'] = ApiClient.convertToType(data['registerCount'], 'Number');
            }
            if (data.hasOwnProperty('registerTotalPrice')) {
                obj['registerTotalPrice'] = ApiClient.convertToType(data['registerTotalPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMinPrice')) {
                obj['registerMinPrice'] = ApiClient.convertToType(data['registerMinPrice'], 'Number');
            }
            if (data.hasOwnProperty('registerMaxPrice')) {
                obj['registerMaxPrice'] = ApiClient.convertToType(data['registerMaxPrice'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Date} targetDate
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['targetDate'] = undefined;

/**
 * @member {Number} transactionCount
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['transactionCount'] = undefined;

/**
 * @member {Number} transactionTotalPrice
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['transactionTotalPrice'] = undefined;

/**
 * @member {Number} transactionTotalFee
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['transactionTotalFee'] = undefined;

/**
 * @member {Number} registerCount
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['registerCount'] = undefined;

/**
 * @member {Number} registerTotalPrice
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['registerTotalPrice'] = undefined;

/**
 * @member {Number} registerMinPrice
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['registerMinPrice'] = undefined;

/**
 * @member {Number} registerMaxPrice
 */
PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData.prototype['registerMaxPrice'] = undefined;






export default PerplayStatisticsControllerDtoMarketVehicleBoxStatisticsMarketData;

